<h2 id="accrue-toil-dialog-title" mat-dialog-title appLocalizationPopupDirective [localizationCode]="'AccrueToil'">
    {{ 'AccrueToil' | translate: {Default: "Accrue TOIL"} }}
</h2>

<mat-dialog-content id="accrue-toil-dialog-content" [attr.aria-labelledby]="'accrue-toil-dialog-title'">
    <form *ngIf="extraFieldsForm" [formGroup]="extraFieldsForm" [attr.aria-label]="'AccrueToil' | translate: {Default: 'Accrue TOIL'}">
        <mat-form-field appearance="fill">
            <mat-label>
                {{formElements[0].text}}
            </mat-label>

            <mat-select disableOptionCentering formControlName="toilPolicyId">
                <mat-option></mat-option>
                <mat-option *ngFor="let option of employeeToilPolicies" [value]="option.toilPolicy?.id">{{option.toilPolicy?.toilType?.name}} - {{option.toilPolicy?.name}}</mat-option>
            </mat-select>
        </mat-form-field>
    </form>
    
    <app-form-generator 
        [formId]="formId"
        [formData]="formData"
        [emitFormDataTrigger]="getFormData"
        [targetEmployeeTablePermissions]="targetEmployeeTablePermissions"
        (emitFormData)="formDataEmitted($event)"
        (emitFormPristine)="formPristineEmitted($event)"
        (emitFormStatus)="formStatusUpdated($event)"
    ></app-form-generator>
</mat-dialog-content>

<mat-dialog-actions>
    <!-- Explains why Save is unavailable (WCAG 3.3.2) -->
    <span class="form-instructions" id="accrue-toil-instructions" *ngIf="readOnly !== true && formValid === false">
        {{ 'CompleteRequiredFields' | translate: {Default: "Fill in the required fields marked * to save"} }}
    </span>
    <button mat-raised-button type="button" [attr.aria-label]="'Close' | translate: {Default: 'Close'}" appPreventDoubleClick (throttledClick)="close()">{{ 'Close' | translate: {Default: "Close"} }}</button>
    <button 
        *ngIf="readOnly !== true"
        mat-raised-button 
        setColor="primaryColour" 
        color="primary"
        type="button"
        [attr.aria-label]="'Save' | translate: {Default: 'Save'}"
        [disabled]="formValid === false" 
        [attr.aria-describedby]="formValid === false ? 'accrue-toil-instructions' : null"
        appPreventDoubleClick 
        (throttledClick)="getFormData = !getFormData"> 
    {{ 'Save' | translate: {Default: "Save"} }}</button>
</mat-dialog-actions>
